import {createFileRoute} from '@tanstack/react-router';

import {parseIsoDay, parseNonEmpty, parsePage} from '@/lib/search-params';
import {AdvanceLedgerPage} from '@/modules/advance-requests/pages/AdvanceLedgerPage';

/**
 * URL state for the advance transaction ledger. All fields optional so links
 * from elsewhere can land here without params; the page applies concrete
 * defaults (`page ?? 1`, empty filters). `q` is a client-side page search —
 * the API has no text search — kept in the URL for shareable views.
 */
export interface LedgerSearch {
  /** A SITE id — the filter is labelled by the site's SQL Account code (DERP-233). */
  site?: string;
  /**
   * Inclusive SETTLED-date bounds (`yyyy-MM-dd`) — `COALESCE(closed_at,
   * failed_proof_at)`, not the request or payout date (DERP-233).
   */
  from?: string;
  to?: string;
  q?: string;
  page?: number;
}

/**
 * Exported so the URL contract is unit-testable: `renderWithProviders`
 * registers a test route at `path: initialPath`, so a query string there never
 * matches and search params can't be driven through a rendered page. Mirrors
 * `routes/_authenticated/reimbursements/ledger.tsx`.
 */
export const validateLedgerSearch = (search: Record<string, unknown>): LedgerSearch => ({
  site: parseNonEmpty(search.site),
  from: parseIsoDay(search.from),
  to: parseIsoDay(search.to),
  q: parseNonEmpty(search.q),
  page: parsePage(search.page),
});

export const Route = createFileRoute('/_authenticated/advances/ledger')({
  validateSearch: validateLedgerSearch,
  component: AdvanceLedgerPage,
});
